import Officer1 from "../assets/images/officer1.png";
import Officer2 from "../assets/images/officer2.png";
import Officer3 from "../assets/images/officer3.png";
import Officer4 from "../assets/images/officer4.png";
export const president = [
  {
    profileImg: Officer1,

    profileInfo:
      "Vincent Chidindu Asogwa, a seasoned academic, with PhD degree in Agricultural Education from the University of Nigeria, \n" +
      "Nsukka. Currently a senior lecturer at the University of Eswatini, he has authored numerous research books, book chapters, papers and journal articles. He is committed to improving educational outcomes and promoting evidence-based practices in research, teaching and learning.",

    profilePortfolio: "President",
    profileQualification: "PhD in Agricultural Education",
    profileName: "Dr Vincent C. Asogwa",

    id: 1,
  },
];
export const secretary = [
  {
    profileImg: Officer2,

    profileInfo:
      "Sandra Eberechukwu Augustine obtained her PhD degree in Educational Technology from the University of Port Harcourt, Rivers State, Nigeria, where she is also serving as a Lecturer in the Department of Curriculum Studies and Educational Technology, Faculty of Education.  She has interest in  facilitating students' learning and improving their learning outcomes through research and technology-based pedagogical processes and resources. She has numerous journals and book chapters to her credit.",

    profilePortfolio: "Secretary",
    profileQualification: "PhD in Educational Technology",
    profileName: "Dr Sandra E. Augustine",

    id: 2,
  },
];
export const treasurer = [
  {
    profileImg: Officer4,

    profileInfo:
      "Akinyooye Funmilola Elizabeth (nee Ojo) obtained OND and HND in Accountancy at Ibadan Polytechnic, B.Ed, M.Ed and Ph.D in Adult Education from the Department of Adult Education, University of Ibadan. She is currently a Senior Lecturer in the same Department. Her research interest is in Industrial Education and Training. She has over 30 publications in the field of Adult Education focusing on safety training and welfare of employees in the industry and society. She teaches courses at both undergraduate and postgraduate levels.",

    profilePortfolio: "Treasurer",
    profileQualification: "Ph.D in Adult Education",
    profileName: "Akinyooye Funmilola Elizabeth",
    id: 4,
  },
];
export const eswatini = [
  {
    profileImg: Officer3,

    profileInfo:
      "Dlamini Bongani B holds a PhD in curriculum studies obtained from the University of KwaZulu Natal,South Africa.Currently I am a Senior Lecturer in the Department of Education. I have published some papers on curriculum dynamics and teachers' voices in curriculum spaces.",

    profilePortfolio: "Eswatini Representative",
    profileQualification: "William Pitcher Teacher Training College",
    profileName: "Bongani Boy Dlamini (PhD)",

    id: 3,
  },
];
